import { Pipe, PipeTransform } from '@angular/core';

/**
 * @deprecated oldfield
 *
 * @export
 * @class Level2StringPipe
 * @implements {PipeTransform}
 */
@Pipe( { name: 'level2string' } )
export class Level2StringPipe implements PipeTransform {
    transform ( value ) {
        switch ( value ) {
            case 'beginner': {
                return 'новички';
            }
            case 'advanced': {
                return 'продвинутый';
            }
            case 'any': {
                return 'любой';
            }
        }
    }
}

